import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
const $= window.$;

class  Titleinput extends Component {
  constructor(props) {
    super(props);
    this.state = {snap_poll_title: ''};
  }

  titleChange(e){
    this.setState({snap_poll_title: e.target.value});
  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
         if(nextProps.title!=undefined){
            this.setState({
              snap_poll_title : nextProps.title
            })
         }
  }

  render() {
    return (
      <input type="text" maxLength="255" name="snap_poll_title" id="txtPollTitle" className="snap_textbox"  value={this.state.snap_poll_title} onChange={(e)=>this.titleChange(e)}/>
    );
  }
}

export default Titleinput;



// WEBPACK FOOTER //
// ./src/personal_interactions/iseek/Titleinput.js